<template>
  <div class="address-item">
    <div class="address-item-cnt">
      <van-cell
        required
        :title="title"
        :value="value"
        is-link
        @click="showPopup"
        :label="isRequired ? '请选择' + title : ''"
      />
      <van-popup
        closeable
        v-model:show="show"
        position="bottom"
        :style="{ height: '30%' }"
        @close="close"
      >
        <div class="search-bar">
        <van-search
          v-model="searchKeywords"
          placeholder="请输入院校名称关键词"
          clearable
          @search="search"
          @clear="onSearchClear"
        />
      </div>
        <div class="select-item-cnt-cell">
          <van-cell
            v-for="(item, index) in list"
            :key="index"
            :title="item.name"
            @click="select(item.id, item.name)"
          ></van-cell>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
import { getCollegeListForm } from "@/service/form";
import { Toast } from "vant";

export default {
  name: "Select",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
      default: "请选择",
    },
    handlerSelect: {
      type: Function,
    },
    isRequired: {
      type: Boolean,
    },
  },

  setup(props) {
    const state = reactive({
      title: props.title,
      searchKeywords: "",
      value: props.value,
      show: false,
      list: [],
    });

    const fetchData = async (keywords) => {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      const { code, data } = await getCollegeListForm({ key: keywords });
      console.log("data --> ", data);
      if (code === 10000) {
        if (data && data.length > 0) {
          state.list = data;
        }else{
          const nornData = [];
          nornData.value = [{
            id: -1,
            code: '-1',
            name: '其他'
          }]
          state.list = nornData.value;
        }
        // state.finished = true;
        // state.loading = false;
      }
      Toast.clear();
    };

    const search = () => {
      if (state.searchKeywords.trim()) {
        fetchData(state.searchKeywords);
      } else {
        state.list = []; // 清空列表
      }
    };

    const showPopup = () => {
      state.show = true;
    };

    const close = () => {
      state.show = false;
    };

    const select = (key, value) => {
      state.selectedValue = value;
      close();
      props.handlerSelect(key, value);
    };

    const onSearchClear = () => {
      state.list = []; // 清空列表当搜索框清空时
    };

    // 初始化数据
    onMounted(() => {
      state.selectedValue = props.value;
    });

    return {
      ...toRefs(state),
      search,
      showPopup,
      close,
      select,
      onSearchClear,
    };
  },
};
</script>

<style lang="less" scoped>
.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.van-search {
  flex: 1;
}


:deep(.van-cell__label) {
  color: #ee0a24;
}

/* 其他样式根据需要调整 */
</style>